import { Component, inject, Input, signal } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe } from "@ngx-translate/core";

import { ValueText } from "../../../models";
import { DraggableSortListComponent } from "../../draggable-sort-list/draggable-sort-list";

@Component({
  selector: "adaa-items-order-modal",
  imports: [DraggableSortListComponent, TranslatePipe],
  templateUrl: "./items-order-modal.html",
  styleUrl: "./items-order-modal.scss",
})
export class ItemsOrderModalComponent {
  modal = inject(NgbActiveModal);

  @Input() data: ValueText[] = [];
  @Input() inputLabel: string = "";

  values = signal<number[]>([]);

  public save(): void {
    this.modal.close(this.values());
  }
}
